const cartCookieExpires = new Date('2040-12-17T03:24:00')

const pickExisting = (source, keys) => {
  const target = {}

  if (!source) {
    return target
  }

  keys.forEach((key) => {
    if (source[key] !== undefined && source[key] !== null) {
      target[key] = source[key]
    }
  })

  return target
}

const resolveOrderDetails = (orderDetails) => {
  if (orderDetails && orderDetails.order_details) {
    return Object.assign({}, orderDetails.order_details, orderDetails)
  }

  return orderDetails
}

export const cartCookieOptions = () => {
  return { path: '/', expires: cartCookieExpires }
}

export const clearCartCookies = (cookies) => {
  const expiredOptions = { path: '/', expires: new Date('2020-12-17T03:24:00') }
  const cookieNames = [
    'orderDetails',
    'bookings',
    'bookingsTokens',
    'bookingOptionStates',
    'orderDetailsVouchers',
    'vouchers',
    'cart_step'
  ]

  cookieNames.forEach((name) => {
    cookies.set(name, '', expiredOptions)
    cookies.remove(name)
  })
}

export const safeOrderDetailsForCookie = (orderDetails, previousOrderDetails = null) => {
  const source = resolveOrderDetails(orderDetails)
  const previous = resolveOrderDetails(previousOrderDetails)
  const safeOrderDetails = pickExisting(source, [
    'id_order_escape',
    'id_order_escape_token',
    'id_order',
    'id',
    'token_order',
    'status',
    'expiracy',
    'price',
    'price_to_pay',
    'payment_price',
    'paid',
    'option_payment_mode',
    'voucher_value',
    'voucher_type',
    'voucher_used',
    'multipayment_fee',
    'multipayment_fee_per_person',
    'multipayment_limit_h',
    'firstname',
    'lastname',
    'phone',
    'email',
    'comment',
    'is_company',
    'company_name',
    'address',
    'postal_code',
    'city'
  ])

  if (!safeOrderDetails.id_order_escape && safeOrderDetails.id_order) {
    safeOrderDetails.id_order_escape = safeOrderDetails.id_order
  }

  if (!safeOrderDetails.id_order_escape && safeOrderDetails.id) {
    safeOrderDetails.id_order_escape = safeOrderDetails.id
  }

  if (
    !safeOrderDetails.id_order_escape
    && previous
    && previous.id_order_escape
  ) {
    safeOrderDetails.id_order_escape = previous.id_order_escape
  }

  if (!safeOrderDetails.id_order_escape_token && safeOrderDetails.token_order) {
    safeOrderDetails.id_order_escape_token = safeOrderDetails.token_order
  }

  if (
    !safeOrderDetails.id_order_escape_token
    && previous
    && previous.id_order_escape_token
    && (!safeOrderDetails.id_order_escape || String(safeOrderDetails.id_order_escape) === String(previous.id_order_escape))
  ) {
    safeOrderDetails.id_order_escape_token = previous.id_order_escape_token
  }

  delete safeOrderDetails.id_order
  delete safeOrderDetails.id
  delete safeOrderDetails.token_order

  return safeOrderDetails
}

export const safeBookingsForCookie = (bookings) => {
  if (!Array.isArray(bookings)) {
    return bookings
  }

  return bookings.map((booking) => pickExisting(booking, [
    'id',
    'id_room_reservation',
    'id_room_reservation_token',
    'id_room',
    'room_id',
    'id_room_calendar',
    'company_id',
    'companyid',
    'id_company',
    'room_name',
    'roomname',
    'enigma_name',
    'name_enigma',
    'reservation_date',
    'time_begin',
    'time_end',
    'quantity_player',
    'lang',
    'comment',
    'price',
    'reservation_price',
    'reservation_price_without_promo',
    'price_reservation_total',
    'price_reservation_total_without_promo',
    'last_minute_discount_amount',
    'room_option_name',
    'room_option_description',
    'room_option_price',
    'room_option_price_without_promo',
    'id_room_option',
    'room_options'
  ]))
}

export const safeVouchersForCookie = (vouchers) => {
  if (!Array.isArray(vouchers)) {
    return vouchers
  }

  return vouchers.map((voucher) => pickExisting(voucher, [
    'id_voucher',
    'id_voucher_token',
    'players',
    'games',
    'price',
    'paper_card'
  ]))
}



// WEBPACK FOOTER //
// ./src/components/CartCookieStorage.js